import { httpService } from '@/api/v1/http.service'
import useMutationWithErrorsHandling from '@/hooks/useMutationWithErrorsHandling'

const useSendAvailabilityRequest = ({
  onSuccess,
  onError
}: {
  onSuccess: () => void
  onError: () => void
}) =>
  useMutationWithErrorsHandling({
    mutationFn: async (data: { semesterId: string; userId: string }) =>
      httpService.panel.panelUsersSendAvailabilityRequestCreate(data.userId, {
        semester_id: data.semesterId
      }),
    onSuccess,
    onError
  })

export default useSendAvailabilityRequest
